import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { Autocomplete, Grid, Pagination, PaginationItem, TextField, Typography } from "@mui/material";
import { DataGrid, GridCsvExportMenuItem, GridOverlay, GridToolbarContainer, GridToolbarExportContainer } from "@mui/x-data-grid";
import React, { Fragment, Suspense, memo, useState } from "react";
import { useStyle } from "./style";
import Loader from '../../../../components/loader/loader'
import { useLocation } from "react-router-dom";

const CustomTable = ({ props }) => {
    const classes = useStyle()
     const location = useLocation()
    const handleChange = (event, newValue) => {
      props.setRowsPerPage(newValue);
    }
    const csvOptions = { delimiter: ';' };
    console.log(props,"propsprops");
    
 function CustomToolbar(){
  return(
    <GridToolbarContainer>
      <GridToolbarExportContainer>
      <GridCsvExportMenuItem />
      </GridToolbarExportContainer>
    </GridToolbarContainer>
  )
 }
 const NoRowsOverlay = () => {
  return (
    <GridOverlay>
      <Typography>No data available</Typography>
    </GridOverlay>
  );
};
const handleSearch = (e) =>{
  props.setSearch(e.target.value)
}
  const CustomFooter = () => {
    return(
      <Grid>
        {props.totalFlag && <Typography className='text-end px-2 py-1'>Total : <strong>{props.totalAmount}</strong></Typography>}
        <Grid container className={classes.footer}>
          <Grid className={classes.paginationOne}>
            <Autocomplete
              disablePortal
              id="page"
              value={props.rowsPerPage}
              onChange={handleChange}
              options={props.pageOption}         
              getOptionLabel={(option) => option.toString()}               
              disableClearable
              renderInput={(params) => 
                <TextField {...params} className={classes.paginationAutocomplete}  
              disabled
              sx={{color:"red"}}
                />
              }
              size="small"/>
              <Typography variant="body 1" color={"#ccc"} ml="6px">rows per page</Typography>
          </Grid>

          <Grid>
            <Pagination 
              color="primary" 
              size="small"
              // count={location.pathname === Math.ceil(props.pageCount / props.rowsPerPage) ? Math.ceil(props.pageCount)}
              // count={Math.ceil(props.pageCount)}
               count={
    location.pathname === "reports/products"
      ? Math.ceil(props.pageCount ) // For 'dashboard' route
      : Math.ceil(props.pageCount / props.rowsPerPage) // Other routes
  }
              // count={Math.ceil(props.pageCount / props.rowsPerPage)}
              page={props.page + 1}
              onChange={(event, newPage) => props.setPage(newPage - 1)}
              boundaryCount={1}
              renderItem={(item) => (
              <PaginationItem
                className={classes.pagination}
                slots={{ previous: ArrowLeftIcon , next: ArrowRightIcon  }}
                {...item}
                
              />
            )}
              />
          </Grid>
        </Grid>
      </Grid>
   
    )
 }
  return (
    <Fragment>
      <Grid className="bg-white p-2">
  { location.pathname == "/reports/customerSalesReport" ?   
    <Grid className="flex justify-end mr-3 mb-5">
           <TextField size="small" placeholder= {location.pathname == "/outlets/phonePayLogs" ? 'Search Phone Number' : 'Search'}  onChange={(e)=>handleSearch(e)}/>
        </Grid> : ""}
        <Suspense fallback={<Loader />}>
          <DataGrid
            rows={props.rows}
            columns={props.columns}
            density="compact"
            // loading={props.rows.length === 0}
            className={classes.dataTable}
            components={{
              NoRowsOverlay,
            }}
            slots={{toolbar : CustomToolbar, footer:CustomFooter }}
            disableRowSelectionOnClick={true}
            showColumnVerticalBorder={true}
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            totalAmount={props.totalAmount}
            totalFlag={props.totalFlag}
            paginationModel={{page : props.page, pageSize: props.rowsPerPage}}
            sx={{ '--DataGrid-overlayHeight': '300px', height:'65vh' }}
            
            getRowHeight={() => location.pathname === '/reports/outlet-wallet-transferreport' ? 'auto' : ''}
            // getRowHeight={() => 'auto'}
          />
        </Suspense>
      </Grid>
    </Fragment>
  );
};

export default memo(CustomTable);
